module.exports = __webpack_public_path__ + "static/media/lehman_gender_time_720.41b53dd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/lehman_gender_time_720.png
// module id = 363
// module chunks = 0